'use strict';

define('vb/action/builtin/switchAction',[
  'vb/action/action',
],
(Action) => {
  /** @typedef {import('vb/action/action').Outcome} Outcome */

  /**
   * Represents a switch action that evaluates a condition and returns a corresponding outcome.
   *
   * @extends Action
   * @category Action
   */
  class SwitchAction extends Action {
    /**
     * Evaluates the given parameters and returns a corresponding outcome based on the case value.
     *
     * @param {Object} parameters - The input parameters for the switch action.
     * @param {string} parameters.caseValue - Expression, the resulting 'case'.
     * @param {Array<string>} [parameters.possibleValues] - An optional array of possible values for 'caseValue'.
     * If provided, the case will be 'default' if it does not appear in this list.
     * @returns {Outcome} The outcome of the switch action.
     */
    // eslint-disable-next-line class-methods-use-this
    perform(parameters) {
      const cases = parameters.possibleValues;
      const cse = parameters.caseValue;

      let caseStr = (cse === undefined || cse === null) ? 'default' : `${cse}`;

      if (cases && cases.length && cases.indexOf(caseStr) < 0) {
        caseStr = 'default';
      }

      return Action.createOutcome(caseStr);
    }
  }

  return SwitchAction;
});

